import { DealernetApi } from "./DealernetApi";

export const CONTROLLER_PATH = "CoreCredit"

export class EntitlementsService {
  public static async GetEntitlements(params: any):Promise<any> {
    const response = await DealernetApi.client().post(
      `${CONTROLLER_PATH}/GetEntitlements`, params);

    return response
  }

  public static async GetCoreCreditRequests(params: any):Promise<any>{
    const response = await DealernetApi.client().post(
      `${CONTROLLER_PATH}/GetCoreCreditRequests`, params);
    
    return response
  }

  public static async GetCoreCredits( params: any) {
    const response = await DealernetApi.client().post(
      `${CONTROLLER_PATH}/GetCoreCredits`, params);
    
    return response
  }

  public static async CreateCorePurchaseRequest (accountId, userId, siteName, params: any ):Promise<any> {
    const response = await DealernetApi.client().post(
      `${CONTROLLER_PATH}/CreateCorePurchaseRequest?accountId=${accountId}&userId=${userId}&siteName=${siteName}`, params);

      return response;
  }
  
  public static async SubmitCoreCreditRequest(params){
    const response = await DealernetApi.client().post(
      `${CONTROLLER_PATH}/SubmitCoreCreditRequest`, params);
    
      return response;
  }

  public static async IsCcrSubmissionEnabled(){
    const response = await DealernetApi.client().get(`${CONTROLLER_PATH}/IsCcrSubmissionEnabled`);
    return response;
  }

  public static GetFileUrlByTitle(title){
    return window.appGlobals.PART_IMAGES_API_URL + "Media/FileByTitle?title=" + title;
  }
};